import InstantComponent from "components/dashboard/product-template-table/components/templates/instant";
import MultiForeignKey
    from "components/dashboard/product-template-table/components/templates/multi-foreign-key/multiForeignKey";
import MultiValue from "components/dashboard/product-template-table/components/templates/multi-value";
import React from "react";
import {IDataCellProps} from "../../../../utils/cellInterfaces";
import {
    GetDatetime,
    GetDouble,
    GetForeignKey,
    GetInstant,
    GetLong, GetMultiForeignKey,
    GetMultiValue,
    GetString,
    GetTime,
    GetTimespan,
    GetUsersignature
} from "../../../../utils/defaultAttributes";
import {CellType} from "utils/enums";
import {ITableDataEntryValue} from "../../../../utils/interfaces";
import DateTime from "../../datatime";
import Double from "../../double";
import ForeignKey from "../../foreign-key/foreignKey";
import Long from "../../long";
import {String} from "../../string/string";
import Time from "../../time";
import Timespan from "../../timespan";
import UserSignature from "../../user-signature";

export function DataCell(props: IDataCellProps) {

    // @ts-ignore
    let cellObj: ITableDataEntryValue = props.dataValue.entries[props.headerConfig.referenceName];
    if (cellObj === undefined) {
        // Loads default values if not found in data, but found in config
        switch (props.headerConfig.type) {
            case (CellType.TIME):
                cellObj = GetTime();
                break;
            case (CellType.USER_SIGNATURE):
                cellObj = GetUsersignature();
                break;
            case (CellType.DATETIME):
                cellObj = GetDatetime();
                break;
            case (CellType.DOUBLE):
                cellObj = GetDouble();
                break;
            case (CellType.LONG):
                cellObj = GetLong();
                break;
            case (CellType.STRING):
                cellObj = GetString();
                break;
            case (CellType.TIMESPAN):
                cellObj = GetTimespan();
                break;
            case (CellType.FOREIGN_KEY):
                cellObj = GetForeignKey();
                break;
            case (CellType.INSTANT):
                cellObj = GetInstant();
                break;
            case CellType.MULTI_VALUE:
                cellObj = GetMultiValue();
                break;
            case CellType.MULTI_FOREIGN_KEY:
                cellObj = GetMultiForeignKey();
                break;
            default:
                console.info("Default cell of column type:" + props.headerConfig.type + " not implemented, returning undefined...");
                return <Undefined/>
        }
    }

    // here only pass value to parent state that should be updated
    const handleParentStateChange = (receivedValue: any) => {
        //  TODO set default value if cell does not exists
        try {
            let exists = props.dataValue.entries[props.headerConfig.referenceName] !== undefined;
            if (exists) {
                props.changeHandler(props.indexEntry, props.headerConfig.referenceName, receivedValue);
            } else {
                cellObj.value = receivedValue;
                cellObj.referenceName = props.headerConfig.referenceName;
                props.changeHandler(props.indexEntry, props.headerConfig.referenceName, receivedValue, cellObj);
            }
        } catch (err) {
            console.log("Error: " + err + ", ")
        }
    }

    const toggleParentFunction = () => {
        try {
            let exists = props.dataValue.entries[props.headerConfig.referenceName] !== undefined;
            if (exists) {
                props.onClickSign(props.indexEntry, props.headerConfig.referenceName);
            } else {
                cellObj.referenceName = props.headerConfig.referenceName;
                props.onClickSign(props.indexEntry, props.headerConfig.referenceName, cellObj);
            }
        } catch (err) {
            console.log("Error while triggering parent sign column");
        }
    }

    const edit = props.headerConfig?.locked ? !props.headerConfig.locked : props.isInEditMode;

    const columnType = cellObj.type;
    switch (columnType) {
        case CellType.LONG: {
            // @ts-ignore
            return <Long value={cellObj.value} selectionValues={props.headerConfig.selectionValues}
                         unit={props.headerConfig.unit ? props.headerConfig.unit : ''}
                         bgHighlightRanges={props.headerConfig.bgHighlightRanges}
                         isInEditMode={edit}
                         changeHandler={handleParentStateChange}
            />
        }
        case CellType.DOUBLE: {
            // @ts-ignore
            return <Double value={cellObj.value} selectionValues={props.headerConfig.selectionValues}
                           unit={props.headerConfig.unit ? props.headerConfig.unit : ''}
                           isInEditMode={edit}
                           precision={props.headerConfig.decimalPlaces || props.headerConfig.decimalPlaces === 0 ? props.headerConfig.decimalPlaces : 2}
                           bgHighlightRanges={props.headerConfig.bgHighlightRanges}
                           changeHandler={handleParentStateChange}
            />
        }
        case CellType.STRING: { // selectone, visa kita neimplementuota dar
            var isShortenText = props.headerConfig.shortenText !== undefined ? props.headerConfig.shortenText : false;
            // @ts-ignore
            return <String value={cellObj.value}
                // @ts-ignore
                           selectionValues={props.headerConfig.selectionValues}
                           unit={props.headerConfig.unit ? props.headerConfig.unit : ''}
                           changeHandler={handleParentStateChange}
                           isInEditMode={edit}
                           shortenText={isShortenText}
            />
        }
        case CellType.DATETIME: { // postinimas blogas(duomenu issaugojimas)
            // @ts-ignore
            return <DateTime value={cellObj.value} format={props.headerConfig.dateDisplayPattern} isInEditMode={edit}
                             changeHandler={handleParentStateChange}
            />
        }
        case CellType.TIMESPAN: {
            // @ts-ignore
            return <Timespan timespan={cellObj.value} isInEditMode={edit} changeHandler={handleParentStateChange}/>
        }
        case CellType.TIME: {
            // @ts-ignore
            return <Time value={cellObj.value} isInEditMode={edit} changeHandler={handleParentStateChange}
                         unit={props.headerConfig.unit ? props.headerConfig.unit : ''}/>
        }
        case CellType.USER_SIGNATURE: {
            // @ts-ignore
            return <UserSignature value={cellObj.value} isInEditMode={edit} changeHandler={toggleParentFunction}/>
        }
        case CellType.FOREIGN_KEY: {
            // @ts-ignore
            return <ForeignKey value={cellObj.value}
                               editable={edit}
                               foreignTemplateKey={props.headerConfig.foreignTemplate || ""}
                               changeHandler={handleParentStateChange}
                               foreignKeyWrap={props.foreignKeyWrap}
            />
        }
        case CellType.INSTANT: // @ts-ignore
            return <InstantComponent value={cellObj.value} format={props.headerConfig.dateDisplayPattern} isInEditMode={edit} changeHandler={handleParentStateChange}/>

        case CellType.MULTI_VALUE: // @ts-ignore
            return <MultiValue value={cellObj.value} isInEditMode={edit} changeHandler={handleParentStateChange} selectionValues={props.headerConfig.selectionValues} subType={props.headerConfig.subType}/>

        case CellType.MULTI_FOREIGN_KEY: // @ts-ignore
            return <MultiForeignKey value={cellObj.value} editable={edit} foreignTemplateKey={props.headerConfig.foreignTemplate || ""} changeHandler={handleParentStateChange} foreignKeyWrap={props.foreignKeyWrap}/>

        default: {
            return <Undefined/>
        }
    }
}

const Undefined = () => {
    return <div style={{
        textAlign: "center"
    }}>NULL</div>
}